import { api } from "../api";

type TicketJustifyRequestType = {
    id: number;
    description: string;
    userId: number;
};

/**
 * ticketSaveJustify - Function that saves on database a new ticket justification   
 * /tickets/${id}/justfies  
 * method POST  
 * @async-function  
 */
const ticketSaveJustification = async (token: string, id: number, model: TicketJustifyRequestType) => {
    const response = await api.post(
        `/tickets/${id}/justifications`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default ticketSaveJustification;